//================== Share Types =============//

const SHARE_TYPES = {
  NORMAL: 'share_normal',
  REGISTER: 'share_register',
  TOPUP: 'share_topup',
  WITHDRAW: 'share_withdraw',
  POCKET_MONEY: 'share_pocket_money',
  SPIN: 'share_spin',
}

export default SHARE_TYPES;